// IMPORTS
// OHS
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { deviceModel } from './../_variables';


// COMPONENT
export default function Device (props) {
   // Functions
   const updateDevice = function () {
      OHSCRUD({
         url: '/v1/oneport/devices/' + props.content.id.value,
         method: 'PUT',
         payload: OHSFormDataExtractor('oneport-device'),
         success: function (data) {
            var temp = props.parent.devices;
            temp[props.index] = OHSListDataFormatter(data[0], deviceModel);
            props.parent.setDevices(temp)
            props.onehive.appWideContent.oneport.buildNavigation(); // refresh the locations + devices in the nav menu
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteDevice = function () {
      OHSCRUD({
         url: '/v1/oneport/devices/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.devices;
            temp.splice(props.index, 1);
            props.parent.setDevices(temp);
            props.onehive.appWideContent.oneport.buildNavigation(); // refresh the locations + devices in the nav menu
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this device?",
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div id='oneport-device' className='oneport-device' onKeyDown={(e) => {OHSFormSubmitListener(e, updateDevice);}}>
         <OHSFormItem onehive={props.onehive} title="Name">
            <input type='text' className='ohsinput' defaultValue={props.content.name.value} data-ohsformdata='name' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Location">
            <OHSFormSelectBuilder content={props.parent.locations} selected={props.content.location_id.value} field='name' blank={false} ohsformdata="location_id" />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Collection">
            <OHSFormSelectBuilder content={props.parent.collections} selected={props.content.collection_id.value} field='name' blank={true} ohsformdata="collection_id" />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Number of Ports">
            <p className='oneport-device-numportsinfo'>{props.content.number_of_ports.value}</p>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="IP Address">
            <input type='text' className='ohsinput' defaultValue={props.content.ip_address.value} data-ohsformdata='ip_address' />
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} update={updateDevice} clear={() => {OHSFormDataClearer('oneport-device');}} delete={deleteDevice} keyListener={true} />
      </div>
   );
}